import React, { FunctionComponent, SVGProps, useRef, useState } from "react";

interface SidebarItemProps {
  href?: string;
  LogoComponent: FunctionComponent<SVGProps<SVGSVGElement> & { title?: string | undefined }>;
  title: string;
  onClick?: () => void;
  includePaths?: string[];
  external?: boolean;
}

const SidebarItem: React.FC<SidebarItemProps> = ({
  href,
  LogoComponent,
  title,
  onClick,
  includePaths,
  external
}) => {
  const isActive =
    (href && window.location.pathname.startsWith(href)) ||
    (includePaths || []).includes(window.location.pathname) ||
    (includePaths || []).some(path => window.location.pathname.startsWith(path));
  const [isHovered, setIsHovered] = useState(false);
  const hoverTimeout = useRef<NodeJS.Timeout | null>(null);
  const handleMouseEnter = () => {
    hoverTimeout.current = setTimeout(() => {
      setIsHovered(true);
    }, 1000);
  };

  const handleMouseLeave = () => {
    if (hoverTimeout.current) {
      clearTimeout(hoverTimeout.current);
    }
    setIsHovered(false);
  };

  return (
    <li
      className="relative"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      {...{ onClick }}
    >
      {href ? (
        <a
          href={href}
          target={external ? "_blank" : undefined}
          rel={external ? "noopener noreferrer" : undefined}
          className={`flex items-center justify-center p-3 my-2  ${
            isActive
              ? "border-l-4 border-blue-500"
              : "hover:shadow-lg hover:scale-110 transition-transform"
          }`}
        >
          <LogoComponent className={`${isActive ? "text-[#FFFFFF]" : "text-[#999999]"}`} />
        </a>
      ) : (
        <div
          className={`group flex items-center justify-center p-3 my-2  cursor-pointer ${
            isActive
              ? "border-l-4 border-blue-500"
              : "hover:shadow-lg hover:scale-110 transition-transform"
          }`}
        >
          <LogoComponent
            className={`group-hover:rotate-45 transition-transform ${
              isActive ? "text-[#FFFFFF]" : "text-[#999999]"
            }`}
          />
        </div>
      )}
      {isHovered && (
        <div className="absolute text-xs left-16 top-5 z-50 ml-2 px-2 py-1 bg-gray-950 text-white rounded-lg shadow-lg text-nowrap">
          {title}
          <svg
            className="absolute left-[-8px] top-1/2 transform -translate-y-1/2"
            width="8"
            height="8"
            viewBox="0 0 8 8"
          >
            <polygon points="0,4 8,0 8,8" />
          </svg>
        </div>
      )}
    </li>
  );
};

export default SidebarItem;
